import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableRoleRoutes = Loadable(
  './RoleRoutes',
  () => import(/* webpackChunkName: "Role" */ './RoleRoutes'),
  () => [(require as any).resolveWeak('./RoleRoutes')]
);
